import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import { catchError } from 'rxjs/operators';
import {ErrorService} from './error.service';
import {ListNavigationService} from "../components/list-navigation/list-navigation.service";

@Injectable({
    providedIn: 'root',
})
export class BackendApiService {
    private apiUrl = '/api';

    constructor(
        private http: HttpClient,
        private errorService: ErrorService,
        private listNavigationService: ListNavigationService,
    ) {}

    get(path: string, params: any = {}): Observable<any> {
        return this.http.get(this.apiUrl + path, {params})
            .pipe(
                catchError((error: HttpErrorResponse) => {
                    if (error.status == 401) {
                        if (!location.href.includes('/auth/login')) {
                            localStorage.setItem('autologout', '1');
                            location.href = '/new_cdb/auth/login';
                        }
                        return throwError(() => new Error('Please login again'));
                    } else if (error.status == 403) {
                        const errorMessage = this.errorService.getErrorMessage(error);
                        return throwError(() => Object.assign(new Error(errorMessage), {status: 403}));
                    } else {
                        const errorMessage = this.errorService.getErrorMessage(error);
                        // Keep the HTTP status and the response's `data` (e.g. a 404's details) next to the message.
                        // Non-enumerable, so the error still looks like a plain Error to existing handlers
                        // (e.g. `if (err && Object.keys(err).length)`, JSON.stringify, spreading).
                        return throwError(() => Object.defineProperties(new Error(errorMessage), {
                            status: {value: error.status, enumerable: false, writable: true, configurable: true},
                            data: {value: error.error?.data ?? null, enumerable: false, writable: true, configurable: true},
                        }));
                    }
                })
            )
    }

    getList(path: string, params: any = {}) {
        this.listNavigationService.saveListApiUrl(
            path + (Object.keys(params).length ? '?' + new URLSearchParams(params) : '')
        );

        return this.get(path, params);
    }

    post(path: string, body: {}) {
        return this.http.post(this.apiUrl + path, body)
            .pipe(catchError(this.handleError))
    }

    patch(path: string, body: {}) {
        return this.http.patch(this.apiUrl + path, body)
            .pipe(catchError(this.handleError))
    }

    put(path: string, body: {}) {
        return this.http.put(this.apiUrl + path, body)
            .pipe(catchError(this.handleError))
    }

    delete(path: string) {
        return this.http.delete(this.apiUrl + path)
            .pipe(catchError(this.handleError))
    }

    handleError(error: HttpErrorResponse) {
        if (error.status == 401 && !location.href.includes('/auth/login')) { 
            localStorage.setItem('autologout', '1');
            location.href = '/new_cdb/auth/login';
        
            return throwError(() => new Error('Please login again'));
        } else {
            return throwError(() => error);
        }
    }

    downloadFile(path: string): Promise<any> {
        return this.http.get(this.apiUrl + path, {
            responseType: 'blob',
            observe: 'response'
        }).toPromise();
    }
}
